/**
 * Common Switch Props
 */
export const switchProps = {
    size: [Number, String],
    value: null,
    loading: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    activeColor: String,
    inactiveColor: String,
    activeValue: {
        type: null,
        default: true,
    },
    inactiveValue: {
        type: null,
        default: false,
    },
};
